import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Receive.svg'

export const IconReceive = IconSVG as IconComponent
